import { checkPropTypes } from 'prop-types'
import React from 'react'

export default function CheckIcon({ styles, width, height }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66669 10.388L4.47135 8.19271L3.52869 9.13538L6.66669 12.2734L13.138 5.80204L12.1954 4.85938L6.66669 10.388Z"
        fill="#27AE60"
      />
    </svg>
  )
}

CheckIcon.propTypes = {
  styles: checkPropTypes.any,
  width: checkPropTypes.string,
  height: checkPropTypes.string,
}
